
import React from 'react';
import { Helmet } from 'react-helmet-async';

import SubHeader from '../components/SubHeader';
import AboutUs from '../components/AboutUs';
import VisionMission from '../components/VisionMission';
import BestSelling from '../components/BestSelling';
import Testimonials from '../components/Testimonials';
import HowWeWork from '../components/HowWeWork';
import Faq from '../components/Faq';
import OurClinets from '../components/OurClinets';

const About = () => {
  const aboutSchema = {
    "@context": "https://schema.org",
    "@type": "LocalBusiness",
    "name": "Best Interior Designer in Nagpur | ERA Interio",
    "description":
      "Discover ERA Interio, a trusted interior design company creating stylish, functional and beautiful spaces tailored to your lifestyle in Nagpur.",
    "image":
      "https://www.erainterio.com/static/media/eraintrerio-01.619cace3e540999f3bf5.png",
    "@id": "https://www.erainterio.com/about-us#localbusiness",
    "url": "https://www.erainterio.com/about-us",
    "telephone": "+91-8830219839",
    "address": {
      "@type": "PostalAddress",
      "streetAddress":
        "Shop No.2, 1st Floor, Shyama Apartment, Pratap Nagar Square, Pratap Nagar",
      "addressLocality": "Nagpur",
      "addressRegion": "Maharashtra",
      "postalCode": "440022",
      "addressCountry": "IN"
    },
    "geo": {
      "@type": "GeoCoordinates",
      "latitude": 21.1130412,
      "longitude": 79.0561782
    },
    "openingHoursSpecification": [
      {
        "@type": "OpeningHoursSpecification",
        "dayOfWeek": [
          "Monday",
          "Tuesday",
          "Wednesday",
          "Thursday",
          "Friday",
          "Saturday",
          "Sunday"
        ],
        "opens": "10:00",
        "closes": "19:00"
      }
    ],
    "department": {
      "@type": "LocalBusiness",
      "name": "Era Interio",
      "telephone": "+91-8830219839",
      "image":
        "https://www.erainterio.com/static/media/eraintrerio-01.619cace3e540999f3bf5.png"
    }
  };

  return (
    <>
      <Helmet>
        {/* SEO Title */}
        <title>
          Best Interior Designer in Nagpur | Living Room & Bedroom
        </title>

        {/* Meta Description */}
        <meta
          name="description"
          content="Planning a home makeover? Our interior design company is the best interior designer in Nagpur for luxury bedrooms and complete homes."
        />

        {/* Keywords */}
        <meta
          name="keywords"
          content="Best Interior Designer in Nagpur, Interior Design Company, Interior Decorator Near Me, Luxury Bedroom Interior Design, Top Interior Designers in Nagpur, Interior Designer Nagpur"
        />

        {/* Robots */}
        <meta
          name="robots"
          content="index, follow, max-image-preview:large"
        />

        {/* Canonical */}
        <link
          rel="canonical"
          href="https://www.erainterio.com/about-us"
        />

        {/* Open Graph */}
        <meta
          property="og:title"
          content="Best Interior Designer in Nagpur | Where Luxury Feels Like Home"
        />

        <meta
          property="og:description"
          content="Discover ERA Interio, a trusted best interior design company creating stylish, functional and beautiful spaces tailored to your lifestyle."
        />

        <meta
          property="og:type"
          content="website"
        />

        <meta
          property="og:url"
          content="https://www.erainterio.com/about-us"
        />

        <meta
          property="og:image"
          content="https://www.erainterio.com/static/media/about-img-1.46bf87808fc6f30b56af.jpg"
        />

        <meta
          property="og:site_name"
          content="ERA Interio"
        />

        {/* Twitter */}
        <meta
          name="twitter:card"
          content="summary_large_image"
        />

        <meta
          name="twitter:title"
          content="Best Interior Designer in Nagpur | Where Luxury Feels Like Home"
        />

        <meta
          name="twitter:description"
          content="Discover ERA Interio, a trusted interior design company creating stylish, functional and beautiful spaces tailored to your lifestyle in Nagpur."
        />

        <meta
          name="twitter:image"
          content="https://www.erainterio.com/static/media/about-img-1.46bf87808fc6f30b56af.jpg"
        />

        {/* Structured Data */}
        <script type="application/ld+json">
          {JSON.stringify(aboutSchema)}
        </script>
      </Helmet>

      <SubHeader
        seoTitle="Best Interior Design Company for Your Dream Home"
      />

      <AboutUs />
      <VisionMission />
      <BestSelling />
      <Testimonials />

      {/* <OurTeam /> */}

      <HowWeWork />
      <Faq />
      <OurClinets />
    </>
  );
};

export default About;
